<script lang="ts" setup>
import NumberField from '@/components/forms/NumberField/NumberField.vue';
import VeeNumberField from '@/components/forms/NumberField/VeeNumberField.vue';
import { FormMode } from '@/components/forms/types';
import { getFormattingOptionsFromEvaluationParameter, toDisplayValue } from '@/utils/numberUtils';
import { isNumber } from 'lodash';
import { useFieldValue } from 'vee-validate';
import { computed } from 'vue';
import {
  type EvaluationParameterDto,
  NumericEvaluationParameterDtoTypeEnum,
} from '@/api/generator';

interface LimitFieldProps {
  name: string;
  mode: FormMode;
  disabled: boolean;
  icon: string;
  label: string;
  suffix?: string | null;
  placeholder?: string;
  iconColor: 'RED' | 'YELLOW';
  numberOfDisplayedDecimals?: number | null;
  valueType?: string | null;
  evaluationType?: string | null;
}

const props = defineProps<LimitFieldProps>();

const fieldValue = useFieldValue<number>(props.name);

const formatOptions = computed(() => {
  const evaluation = {
    $type:
      NumericEvaluationParameterDtoTypeEnum.PtwPtw100AppZeroApplicationSharedTaskItemComponentDtoEvaluationParametersNumericEvaluationParameterDtoPtwPtw100AppZeroApplicationShared,
    definition: { valueType: props.valueType },
    evaluationType: props.evaluationType,
    decimalPlaces: props.numberOfDisplayedDecimals,
    evaluationUnitAbbreviation: null,
  } as unknown as EvaluationParameterDto;

  return getFormattingOptionsFromEvaluationParameter(evaluation);
});

const displayValue = computed(() => {
  return toDisplayValue(fieldValue.value, formatOptions.value);
});
</script>

<template>
  <VeeNumberField
    v-if="mode !== 'details'"
    :label="label"
    mode="edit"
    :disabled="disabled"
    :prependInnerIcon="icon"
    class="w-100"
    :class="iconColor === 'RED' ? 'red-icon' : 'yellow-icon'"
    :suffix="suffix"
    :name="name"
    :placeholder="placeholder"
    :format="{
      valueType: formatOptions?.valueType ?? 'FloatingPoint',
    }"
  />
  <NumberField
    v-else
    :value="displayValue"
    :disabled="true"
    :suffix="isNumber(fieldValue) ? suffix : ''"
    :prependInnerIcon="icon"
    :placeholder="placeholder"
    class="w-100 display"
    :class="iconColor === 'RED' ? 'red-icon' : 'yellow-icon'"
    :label="label"
  />
</template>

<style lang="scss" scoped>
.yellow-icon {
  ::v-deep(.v-field__prepend-inner) {
    path {
      fill: rgb(var(--v-theme-warning-lighten-1)) !important;
    }
  }
}

.red-icon {
  ::v-deep(.v-field__prepend-inner) {
    path {
      fill: rgb(var(--v-theme-error-lighten-1)) !important;
    }
  }
}
.display {
  ::v-deep(.v-field) {
    opacity: 1 !important ;
    border: none !important;
    border-radius: 10px !important;
    background-color: #f3f3f3 !important;
  }
  ::v-deep(.v-label) {
    opacity: 1 !important;
    color: rgb(var(--v-theme-primary-lighten-1));
  }

  ::v-deep(.v-field__outline) {
    display: none !important;
  }
  ::v-deep(.v-field__overlay) {
    display: none;
  }
}
</style>
